<template>
  <div>
    <transition name="modal">
      <modal v-if="showModal" @modal-close="modalClose()" modal-type="alt" is-close="true">
        <template v-if="isLogged">
            <ModalProductListNotification :urlImage="urlImage" :idProduct="idProduct" :urlProduct="urlProduct" @modal-close="modalClose"></ModalProductListNotification>
        </template>
        <template v-else>
            <ModalProductListNotification :urlImage="urlImage" :idProduct="idProduct" :urlProduct="urlProduct" @modal-close="modalClose" is-form></ModalProductListNotification>
        </template>
      </modal>
    </transition>
  </div>
</template>
<script>

import { trinyConfig } from '@/config'

import Modal from '@/components/Modal.vue'
import ModalProductListNotification from '@/components/ProductListNotification/ProductListNotificationModalSave.vue'
import { bindClickEventWithPreventDefault } from '@/shared'

export default {
  props: ['idProduct', 'urlProduct', 'urlImage'],

  components: {
    Modal,
    ModalProductListNotification
  },

  data () {
    return {
      showModal: false,
      isLogged: false
    }
  },

  created () {
    const buttonWrapper = '.js-notification-open-list' + this.idProduct
    bindClickEventWithPreventDefault(document, buttonWrapper, () => {
      this.modalOpen()
    })
  },

  mounted () {
    this.isLogged = trinyConfig.logged
  },

  methods: {
    modalOpen () {
      event.preventDefault()

      this.showModal = true
    },

    modalClose () {
      this.showModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProductListNotification/ProductListNotification.vue